enum VyChatTypeEnum {
    LivePerson = "LivePerson",
    PoshLivePerson = "PoshLivePerson",
    Glia = "Glia",
    None = "None"
}

export default VyChatTypeEnum;
